import { createFileRoute } from '@tanstack/react-router'
import { CanView } from '@/components/can-view'
import { TeamsPage } from '@/features/teams'

export const Route = createFileRoute('/_authenticated/settings/teams')({
	component: () => (
		<CanView permission='settings.permissions.manage'>
			<TeamsPage />
		</CanView>
	),
})
